export default {
  // specific brand application state - path subject to change based on initGmi pathConfig
  app: {},

  gmi: {
    // unified request in progress bool
    fetching: {
      cda: false,
      solr: false,
      gma: false,
      cda_services: [],
      gma_services: [],
      solr_services: []
    },

    // unified error/app messaging
    messages: {
      cda: [],
      solr: [],
      gma: [],
      cda_services: {},
      gma_services: {},
      solr_services: {}
    },

    // data structures created by gmi actions not tied to UIs; i.e. actions.saveFilteredArraysOfObjects
    data: {
      filters: {}
    },

    // data structures created by gmi actions directly tied to UIs; i.e. actions.composeFiltersUiShape
    ui: {
      // store filtering arrays of objects by various object key paths for use with filters UI
      filters: {},
      reservations: {
        car_class: {
          redemption_day_count: false
        },
        commit: {},
        driver_profile: {
          contact: {},
          address: {},
          drivers_license: {}
        },
        extras: [],
        initiate: {}
      },
      replacement: {
        driver: {
          searchByDriverLicense: {
            country: null,
            country_subdivision: null,
            driver_license_number: null
          },
          confirm: {
            phones: [],
            address: {
              street_addresses: []
            }
          }
        },
        location: {
          submit: {
            pickup_delivery_address: {
              street_addresses: []
            }
          }
        }
      },
      rewards: {
        history: {
          page_number: 1,
          start_date: "",
          end_date: ""
        }
      },
      id_verify: {
        sdk_loading: false,
        sdk_initialized: false
      },
      google_maps: {
        api_loaded: false,
        libraries: []
      }
    },

    // responses for non-session related GMA/GBO calls
    gma: {
      content: {
        partner_reward_programs_surcharge: {},
        privacy: {},
        // NOTE: these endpoints are NOT in content and actually in reservations in GBO but we anticipate it moving here
        support: {
          contact: {}
        },
        taxes: {},
        terms: {
          loyalty: {},
          prepay: {}
        },
        terms_of_use: {}
      },
      contract: {
        details: {}
      },
      coupon: {
        details: {}
      },
      location: {
        by_id: {},
        countries: {},
        states_or_provinces: {}
      },
      reference: {
        partner_rewards: {},
        security_questions: {}
      },
      reservation: {
        car_class_details: {},
        card_submission_session: {},
        rental_terms: {}
      },
      rewards: {
        // note: we do not store history here as it needs custom data models in ui.rewards.history
        retro_claim: {},
        transfer_points: {}
      },
      trips: {
        current: {},
        invoice: {},
        past: {},
        retrieve: {},
        upcoming: {}
      },
      vehicles: {
        by_country: {}
      },
      ticket: {
        terms_and_conditions: {},
        ibm_data: {},
        card_details: {}
      },
      subscription: {
        details: {}
      },
      extend_rental: {
        eligibility: {},
        initiate: {},
        commit: {}
      },
      emerald_checkout: {
        initiate: {},
        commit: {},
        vehicles: {
          by_session_id: {}
        }
      },
      replacement: {
        payment: {
          initiate: {},
          recordPaymentTransaction: {}
        },
        extras: {
          equipment: [],
          insurance: []
        }
      }
    },

    // session information - path subject to change based on initGmi pathConfig
    session: {
      analytics: {},
      gbo: {},
      gma: {},
      ticket: {}
    },

    // responses for solr calls (app experience can use or ignore to repopulate store.app.key data)
    solr: {
      all: [],
      country: {},
      country_state: {},
      hours: {},
      renter_age: {},
      spatial: {},
      text: {}
    }
  }
};

// cda state structure
export const cda = {
  session: {
    current: {
      analytics: {},
      cda: {},
      deem: {}
    }
  },
  reservation: {
    airline_list: []
  }
};

export const car_and_driver = {
  initiate: {
    pickup: {
      pickup_date_time: "",
      location: {}
    },
    extra_stops: [],
    number_of_passengers: 1,
    requested_duration: 0
  },
  traveler_information: {
    booker: {},
    passenger: {}
  }
};
